import { createAsyncThunk } from '@reduxjs/toolkit';
import { _aiServiceUrls } from '@custom/Utils/constants/apiUrls';

const predictHemorrhageApi = createAsyncThunk(
  'predictHemorrhageApi',
  async (file: File) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_aiServiceUrls.CTBrian}`;

      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `Something went wrong while processing the image`);
      }
      const jsonResponse = await response.json();
      return jsonResponse;
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default predictHemorrhageApi;
